module.exports = __webpack_public_path__ + "static/media/tripp.6c850129.jpg";